import { EditorRoleCode } from "../types/roles.types";

export const ALLOWED_EDITOR_ROLES_AND_CLASSIFICATION_EDIT_ARTICLE: Partial<
  Record<EditorRoleCode, string>
> = {
  EDTK0204: "C000", // Clinical, preclinical, R&D
  EDTK0304: "C001", // Clinical trial status
  EDTK0404: "C005", // Conference, poster contents
  EDTK0504: "C006", // Deal, cooperation
  EDTK0604: "C016", // Expedited & Incentive Programs
  EDTK0704: "C013", // Approval process
  EDTK0804: "C021", // Venture capital, private placement
};

export const ALLOWED_EDITOR_ROLES_AND_CLASSIFICATION_FILL_IN_TABLE: Partial<
  Record<EditorRoleCode, string>
> = {
  EDTK0201: "C000", // Clinical, preclinical, R&D
  EDTK0202: "C000",
  EDTK0204: "C000",
  EDTK0303: "C001", // Clinical trial status
  EDTK0304: "C001",
  EDTK0401: "C005", // Conference, poster contents
  EDTK0402: "C005",
  EDTK0404: "C005",
  EDTK0503: "C006", // Deal, cooperation
  EDTK0504: "C006",
  EDTK0603: "C016", // Expedited & Incentive Programs
  EDTK0604: "C016",
  EDTK0703: "C013", // Approval process
  EDTK0704: "C013",
  EDTK0803: "C021", // Venture capital, private placement
  EDTK0804: "C021",
};

export const ALLOWED_EDITOR_ROLES_AND_CLASSIFICATION_INSERT_IMAGE: Partial<
  Record<EditorRoleCode, string>
> = {
  EDTK0204: "C000", // Clinical, preclinical, R&D
  EDTK0304: "C001", // Clinical trial status
  EDTK0404: "C005", // Conference, poster contents
  EDTK0504: "C006", // Deal, cooperation
  EDTK0604: "C016", // Expedited & Incentive Programs
  EDTK0704: "C013", // Approval process
  EDTK0804: "C021", // Venture capital, private placement
};
